//#region src/components/ui/config-provider/injectionKeys.ts
var e = Symbol("CONFIG_PROVIDER_LOCALE_INJECTION_KEY"), t = Symbol("CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY"), n = Symbol("CONFIG_PROVIDER_DIRECTION_INJECT_KEY");
//#endregion
export { n as CONFIG_PROVIDER_DIRECTION_INJECT_KEY, e as CONFIG_PROVIDER_LOCALE_INJECTION_KEY, t as CONFIG_PROVIDER_TELEPORT_RENDER_DISABLED_INJECT_KEY };

//# sourceMappingURL=injectionKeys.js.map